// extracted by mini-css-extract-plugin
export default {"header":"TopCategories_header__RjgZu","rank":"TopCategories_rank__CLsNS","st":"TopCategories_st__nA5oQ","nd":"TopCategories_nd__0Oy2L","rd":"TopCategories_rd__bKGC8"};